export default __webpack_public_path__ + "static/bridge-a33505087990d3bbf965a65f3a3f065a.png";